import { CategoriaArquivoAtendProfEnum } from 'graphql/types.generated'

export function isCategoriaAnexoResultadoExame(categoria: CategoriaArquivoAtendProfEnum): boolean {
  return (
    categoria === CategoriaArquivoAtendProfEnum.EXAME_DE_IMAGEM_ODONTOLOGICO ||
    categoria === CategoriaArquivoAtendProfEnum.EXAME_DE_IMAGEM
  )
}
